export default __webpack_public_path__ + "static/media/Mysore04.312cffc3.jpg";